var map = {
	"./cover.jpg": 8313,
	"./image1.jpg": 1994,
	"./image2.jpg": 4069,
	"./image3.jpg": 9752,
	"./image4.jpg": 6491,
	"./image5.jpg": 8446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8904;